import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

// TODO: Set VITE_API_URL in your .env file
const BASE_URL = import.meta.env.VITE_API_URL as string;

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30_000,
});

// Request interceptor: attach Cognito JWT token
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // Not authenticated — let the request proceed; 401 interceptor will handle it
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor: surface errors to callers.
// We do NOT hard-redirect on 401 here — Amplify's session state is the source
// of truth for authentication. Backend 401s can mean "no tenant configured"
// for a fully-authenticated Cognito user, and a hard redirect would loop them.
// AuthGuard handles unauthenticated state by watching isAuthenticated from
// AuthContext, which is driven by Amplify, not by backend responses.
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => Promise.reject(error),
);

export default apiClient;
